module.exports = __webpack_public_path__ + "static/work39-c4151101b82e25acca75f39d9ba34658.jpg";